import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const CLARITY_PROJECT_ID = 'wjbklsq9ma'
const ALLOWED_HOSTNAMES = new Set(['tofocus.tech', 'www.tofocus.tech'])

const isClarityEnabled = () => {
  if (typeof window === 'undefined') {
    return false
  }

  return ALLOWED_HOSTNAMES.has(window.location.hostname)
}

const getRouteLabel = pathname => {
  if (pathname === '/') {
    return 'Pomodoro'
  }

  if (pathname === '/tarefas') {
    return 'Tarefas'
  }

  if (pathname === '/matriz') {
    return 'Matriz'
  }

  if (pathname === '/relatorio') {
    return 'Relatório'
  }

  return pathname
}

const ensureClarity = () => {
  if (!isClarityEnabled()) {
    return
  }

  if (window.clarity && document.getElementById('clarity-script')) {
    return
  }

  window.clarity =
    window.clarity ||
    function () {
      ;(window.clarity.q = window.clarity.q || []).push(arguments)
    }

  const script = document.createElement('script')
  script.async = true
  script.id = 'clarity-script'
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`

  const firstScript = document.getElementsByTagName('script')[0]

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
    return
  }

  document.head.appendChild(script)
}

const disableClarity = () => {
  const existingScript = document.getElementById('clarity-script')
  if (existingScript) {
    existingScript.remove()
  }

  if (window.clarity) {
    delete window.clarity
  }
}

const ClarityTracker = () => {
  const location = useLocation()

  useEffect(() => {
    if (!isClarityEnabled()) {
      disableClarity()
      return
    }

    ensureClarity()
  }, [])

  useEffect(() => {
    if (!isClarityEnabled() || !window.clarity) {
      return
    }

    window.clarity('set', 'route', getRouteLabel(location.pathname))
    window.clarity('set', 'path', location.pathname)
  }, [location.pathname])

  return null
}

export { ClarityTracker }
